import { gameState } from '../state/gameState.js';

// Persists the player's current scene + walking position so a page refresh resumes
// where they were (BootScene reads it on load). One scene is active at a time, so a
// module-level throttle is fine.
//
//   reportLocation(scene, x, y, { immediate: true })  → save now (use on scene entry)
//   reportLocation(scene, x, y)                        → throttled, only if moved
//
// For scenes without a walking position (garden, shops) pass x = y = null.

const THROTTLE_MS = 1500;
const MOVE_EPSILON = 4;     // px — ignore sub-pixel jitter

let _lastSaveAt = 0;
let _lastX = null;
let _lastY = null;
let _lastFacing = null;

// The animated-walk prototype publishes the local avatar's 8-way facing here (NatalkaSprite.setMotion).
const currentFacing = () => (typeof window !== 'undefined' && Number.isInteger(window.__myFacing)) ? window.__myFacing : null;

export function reportLocation(scene, x, y, { immediate = false } = {}) {
  const key = scene.scene.key;
  const rx = x == null ? null : Math.round(x);
  const ry = y == null ? null : Math.round(y);

  const facing = currentFacing();
  if (immediate) {
    _lastX = rx; _lastY = ry; _lastFacing = facing; _lastSaveAt = Date.now();
    gameState.setLocation(key, rx, ry, facing);
    return;
  }

  const now = Date.now();
  if (now - _lastSaveAt < THROTTLE_MS) return;
  if (rx != null && _lastX != null && Math.abs(rx - _lastX) < MOVE_EPSILON && Math.abs(ry - _lastY) < MOVE_EPSILON && facing === _lastFacing) {
    return;  // hasn't moved or turned since last save — skip
  }
  _lastX = rx; _lastY = ry; _lastFacing = facing; _lastSaveAt = now;
  gameState.setLocation(key, rx, ry, facing);
}
